import { logParamKey, ticketParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum CompanyTicketRouteName {
    Index = 'company.tickets.index',
    Edit = 'company.tickets.edit',
    Logs = 'company.tickets.logs',
    LogDetails = 'company.tickets.logs.details',
}

export default {
    path: 'tickets',
    name: CompanyTicketRouteName.Index,
    component: () => import('@/views/company/ticket/Index.vue'),
    meta: {
        label: 'Tickets',
        auth: true,
        permission: Permission.TicketViewAny,
    },
    children: [
        {
            path: `:${ticketParamKey}/edit`,
            name: CompanyTicketRouteName.Edit,
            component: () => import('@/views/company/ticket/Index.vue'),
            meta: {
                label: 'Edit Ticket',
                auth: true,
                permission: Permission.TicketUpdate,
            },
        },
        {
            path: `:${ticketParamKey}/logs`,
            name: CompanyTicketRouteName.Logs,
            component: () => import('@/views/company/ticket/Index.vue'),
            meta: {
                label: 'Ticket Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: `:${logParamKey}`,
                    name: CompanyTicketRouteName.LogDetails,
                    component: () => import('@/views/company/ticket/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
    ],
}
